import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RequestState } from '@alltrails/types/belay';
import type { FacebookStatus } from '@alltrails/types/FacebookStatus';
import { getFacebookUploadStatus as getFacebookUploadStatusReq, uploadFacebookTokenToBelay } from '../utils/belayRequests';

export const fetchFacebookUploadStatus = createAsyncThunk('facebook/fetchFacebookUploadStatus', async (userId: number) => {
  const data = await getFacebookUploadStatusReq(userId);
  return data;
});

export const submitFacebookTokenToBelay = createAsyncThunk(
  'facebook/submitFacebookTokenToBelay',
  async ({ token, userId }: { token: string; userId: number }) => {
    const data = await uploadFacebookTokenToBelay(token, userId);
    return data.status;
  }
);

export type FacebookState = {
  // deprecated: https://github.com/alltrails/mugen/pull/229
  appId: string | null;
  facebookStatus: FacebookStatus | null;
  requestState: RequestState;
};

const initialState: FacebookState = {
  appId: null,
  facebookStatus: 'not-submitted',
  requestState: RequestState.Idle
};

export const facebookSlice = createSlice({
  name: 'facebook',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchFacebookUploadStatus.fulfilled, (state, { payload }) => {
      if (!payload.contactUploads) {
        return state;
      }

      state.facebookStatus = payload.contactUploads.facebook.status;
      state.requestState = RequestState.Succeeded;

      return state;
    });
    builder.addCase(submitFacebookTokenToBelay.fulfilled, (state, { payload }) => {
      state.facebookStatus = payload;
      state.requestState = RequestState.Succeeded;

      return state;
    });
  }
});

export default facebookSlice.reducer;
